"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.size = void 0;
exports.size = {
    large: {
        width: "32px",
        height: "32px",
        strokeWidth: 2.4
    },
    medium: {
        width: "24px",
        height: "24px",
        strokeWidth: 2
    },
    small: {
        width: "20px",
        height: "20px",
        strokeWidth: 1.667
    }
};
//# sourceMappingURL=size.js.map